import { Footer } from "../components/Footer";
import { MyTickets } from "../components/MyTickets";
import { MyNavbar } from "../components/Navbar";

export function Tickets() {
  return (
    <>
      <MyNavbar />
      <MyTickets />
      <Footer />
    </>
  );
}
